import { getThemeProperty, styled } from '@ludwig/ui'

export const TextArea = styled.textarea`
width:100%;
border: none;
padding: 16px;
font-size: 16px;
border-radius: 6px;
margin-bottom: 12px;
border: 2px solid transparent;
background: #F4F4F4;
outline: none !important
resize: none;
font-family: ${getThemeProperty('fonts', 'sansSerif')};
&.invalid {
    border-color: ${getThemeProperty('colors', 'coral', 900)};
}
&:focus {
    outline: none !important;
    border-color: ${props => props.theme.colors.blues[200]};
}
`

TextArea.defaultProps = {
    bg: 'smoke.100',
    borderColor: 'smoke.100'
}